import { Box as NbBox } from 'native-base';

import { addWithConfig } from '../../utils';

export const Box = NbBox;

export default addWithConfig(Box);
